import { FC } from 'react'
import { Inline } from '../../../shared/layout/Inline'
import { YellowFilledButton } from '@shared/styles/YellowFilledButton'
import { Footer } from '@shared/layout/DefaultPage'
import { useIonRouter, UseIonRouterResult } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'

interface FooterProps {
	nextLink?: string
}

export const PremiumExerciseFooter: FC<FooterProps> = () => {
	const nav: UseIonRouterResult = useIonRouter()

	return (
		<Footer style={{}}>
			<Inline justify={'center'}>
				<YellowFilledButton
					width={230}
					onClick={() => {
						nav.push(ROUTES.overall.aiMessenger)
					}}>
					Задать вопрос AI тренеру
				</YellowFilledButton>
			</Inline>
		</Footer>
	)
}
